import { NgModule } from '@angular/core';
import { NoPreloading, PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: 'get-started',
    loadChildren: () => import('./get-started/get-started.module').then(m => m.GetStartedPageModule),

  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule),
  },


  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  },


  {
    path: 'signup',
    loadChildren: () => import('./signup/signup.module').then(m => m.SignupPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'product-detail/:abc',
    loadChildren: () => import('./product-detail/product-detail.module').then(m => m.ProductDetailPageModule),
  },
  {
    path: 'chat/:order_id/:to_id',
    loadChildren: () => import('./chat/chat.module').then(m => m.ChatPageModule),
    canActivate : [AuthGuard]
  },
  {
    path: 'search',
    loadChildren: () => import('./search/search.module').then(m => m.SearchPageModule)
  },
  {
    path: 'filter',
    loadChildren: () => import('./filter/filter.module').then(m => m.FilterPageModule)
  },
  {
    path: 'sub-categories',
    loadChildren: () => import('./sub-categories/sub-categories.module').then(m => m.SubCategoriesPageModule),
    canActivate : [AuthGuard]

  },
  {
    path: 'add-category',
    loadChildren: () => import('./add-category/add-category.module').then(m => m.AddCategoryPageModule),
    canActivate : [AuthGuard]
  },

  {
    path: 'forgot-password',
    loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule)
  },
  {
    path: 'edit-profile',
    loadChildren: () => import('./edit-profile/edit-profile.module').then(m => m.EditProfilePageModule),
    canActivate : [AuthGuard]

  },
  {
    path: 'help',
    loadChildren: () => import('./help/help.module').then(m => m.HelpPageModule)
  },
  {
    path: 'notifications',
    loadChildren: () => import('./notifications/notifications.module').then(m => m.NotificationsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'about',
    loadChildren: () => import('./about/about.module').then(m => m.AboutPageModule),
  },
  {
    path: 'image-modal/:abc/:xyz/:page',
    loadChildren: () => import('./image-modal/image-modal.module').then(m => m.ImageModalPageModule)
  },
  {
    path: 'login-phone',
    loadChildren: () => import('./login-phone/login-phone.module').then(m => m.LoginPhonePageModule)
  },
  {
    path: 'phone-verification',
    loadChildren: () => import('./phone-verification/phone-verification.module').then(m => m.PhoneVerificationPageModule)
  },
  {
    path: 'chat-list',
    loadChildren: () => import('./chat-list/chat-list.module').then(m => m.ChatListPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'edit-ad',
    loadChildren: () => import('./edit-ad/edit-ad.module').then(m => m.EditAdPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'order',
    loadChildren: () => import('./order/order.module').then(m => m.OrderPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'order-pictures',
    loadChildren: () => import('./order-pictures/order-pictures.module').then(m => m.OrderPicturesPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'city-list',
    loadChildren: () => import('./city-list/city-list.module').then(m => m.CityListPageModule)
  },
  {
    path: 'checkout',
    loadChildren: () => import('./checkout/checkout.module').then(m => m.CheckoutPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'success',
    loadChildren: () => import('./success/success.module').then(m => m.SuccessPageModule)
  },
  {
    path: 'order-detail',
    loadChildren: () => import('./order-detail/order-detail.module').then(m => m.OrderDetailPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'review-modal',
    loadChildren: () => import('./review-modal/review-modal.module').then(m => m.ReviewModalPageModule),
    canActivate : [AuthGuard]

  },
  {
    path: 'recieved-orders',
    loadChildren: () => import('./recieved-orders/recieved-orders.module').then(m => m.RecievedOrdersPageModule),
    canActivate : [AuthGuard]

  },
  {
    path: 'recieved-orders-detail',
    loadChildren: () => import('./recieved-orders-detail/recieved-orders-detail.module').then(m => m.RecievedOrdersDetailPageModule),
    canActivate : [AuthGuard]

  },
  {
    path: 'dispute',
    loadChildren: () => import('./dispute/dispute.module').then(m => m.DisputePageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'login-type',
    loadChildren: () => import('./login-type/login-type.module').then(m => m.LoginTypePageModule)
  },
  {
    path: 'payment-method/:abc/:xyz',
    loadChildren: () => import('./payment-method/payment-method.module').then(m => m.PaymentMethodPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'invoice/:abc/:xyz',
    loadChildren: () => import('./invoice/invoice.module').then(m => m.InvoicePageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'share-modal',
    loadChildren: () => import('./share-modal/share-modal.module').then(m => m.ShareModalPageModule)
  },
  {
    path: 'transactions',
    loadChildren: () => import('./transactions/transactions.module').then(m => m.TransactionsPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'order-view-detail',
    loadChildren: () => import('./order-view-detail/order-view-detail.module').then(m => m.OrderViewDetailPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'ad-added-rules',
    loadChildren: () => import('./ad-added-rules/ad-added-rules.module').then(m => m.AdAddedRulesPageModule)
  },
  {
    path: 'ad-sale-rules',
    loadChildren: () => import('./ad-sale-rules/ad-sale-rules.module').then(m => m.AdSaleRulesPageModule)
  },
  {
    path: 'rules-modal',
    loadChildren: () => import('./rules-modal/rules-modal.module').then(m => m.RulesModalPageModule)
  },
  {
    path: 'image-modal-detail',
    loadChildren: () => import('./image-modal-detail/image-modal-detail.module').then(m => m.ImageModalDetailPageModule)
  },
  {
    path: 'rules-seller-modal',
    loadChildren: () => import('./rules-seller-modal/rules-seller-modal.module').then(m => m.RulesSellerModalPageModule)
  },
  {
    path: 'rules-reg',
    loadChildren: () => import('./rules-reg/rules-reg.module').then(m => m.RulesRegPageModule)
  },
  {
    path: 'rules-modal-signup',
    loadChildren: () => import('./rules-modal-signup/rules-modal-signup.module').then(m => m.RulesModalSignupPageModule)
  },
  {
    path: 'debit-card',
    loadChildren: () => import('./debit-card/debit-card.module').then(m => m.DebitCardPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'featured-ads',
    loadChildren: () => import('./featured-ads/featured-ads.module').then(m => m.FeaturedAdsPageModule)
  },
  {
    path: 'camera-modal',
    loadChildren: () => import('./camera-modal/camera-modal.module').then(m => m.CameraModalPageModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyPageModule)
  },
  {
    path: 'terms',
    loadChildren: () => import('./terms/terms.module').then(m => m.TermsPageModule)
  },
  {
    path: 'account-delete',
    loadChildren: () => import('./account-delete/account-delete.module').then(m => m.AccountDeletePageModule),
    canActivate : [AuthGuard]

  },
  {
    path: 'report-modal',
    loadChildren: () => import('./report-modal/report-modal.module').then(m => m.ReportModalPageModule)
  },
  {
    path: 'personal-information',
    loadChildren: () => import('./personal-information/personal-information.module').then(m => m.PersonalInformationPageModule),
  },
  {
    path: 'all-orders/:seller_id',
    loadChildren: () => import('./all-orders/all-orders.module').then(m => m.AllOrdersPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'doctors',
    loadChildren: () => import('./doctors/doctors.module').then(m => m.DoctorsPageModule)
  },
  {
    path: 'medicine/:abc',
    loadChildren: () => import('./medicine/medicine.module').then(m => m.MedicinePageModule)
  },

  {
    path: 'pet-food/:abc',
    loadChildren: () => import('./pet-food/pet-food.module').then(m => m.PetFoodPageModule)
  },
  {
    path: 'shopping',
    loadChildren: () => import('./shopping/shopping.module').then(m => m.ShoppingPageModule),
    canActivate : [AuthGuard]

  },
  {
    path: 'lsm-services',
    loadChildren: () => import('./lsm-services/lsm-services.module').then(m => m.LsmServicesPageModule)
  },


  {
    path: 'order-invoice',
    loadChildren: () => import('./order-invoice/order-invoice.module').then(m => m.OrderInvoicePageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'order-list',
    loadChildren: () => import('./order-list/order-list.module').then(m => m.OrderListPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'order-recieved',
    loadChildren: () => import('./order-recieved/order-recieved.module').then(m => m.OrderRecievedPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'pet-toys/:abc',
    loadChildren: () => import('./pet-toys/pet-toys.module').then(m => m.PetToysPageModule)
  },
  {
    path: 'timeline',
    loadChildren: () => import('./timeline/timeline.module').then(m => m.TimelinePageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'supply-details/:abc/:xyz/:page',
    loadChildren: () => import('./supply-details/supply-details.module').then(m => m.SupplyDetailsPageModule)
  },
  {
    path: 'new-category/:abc/:xyz',
    loadChildren: () => import('./new-category/new-category.module').then(m => m.NewCategoryPageModule)
  },
  {
    path: 'goat-for-saqda',
    loadChildren: () => import('./goat-for-saqda/goat-for-saqda.module').then(m => m.GoatForSaqdaPageModule)
  },
  {
    path: 'profile-modal',
    loadChildren: () => import('./profile-modal/profile-modal.module').then(m => m.ProfileModalPageModule)
  },
  {
    path: 'successfully-modal',
    loadChildren: () => import('./successfully-modal/successfully-modal.module').then(m => m.SuccessfullyModalPageModule)
  },
  {
    path: 'cart-history',
    loadChildren: () => import('./cart-history/cart-history.module').then(m => m.CartHistoryPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'cart-histroy-invoice',
    loadChildren: () => import('./cart-histroy-invoice/cart-histroy-invoice.module').then(m => m.CartHistroyInvoicePageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'pet-adopt',
    loadChildren: () => import('./pet-adopt/pet-adopt.module').then(m => m.PetAdoptPageModule)
  },
  {
    path: 'stud-cross',
    loadChildren: () => import('./stud-cross/stud-cross.module').then(m => m.StudCrossPageModule)
  },
  {
    path: 'payment-details',
    loadChildren: () => import('./payment-details/payment-details.module').then(m => m.PaymentDetailsPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'goat-shopping',
    loadChildren: () => import('./goat-shopping/goat-shopping.module').then(m => m.GoatShoppingPageModule),
    // canActivate: [AuthGuard]

  },
  {
    path: 'change-password',
    loadChildren: () => import('./change-password/change-password.module').then( m => m.ChangePasswordPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'sadqa-invoice',
    loadChildren: () => import('./sadqa-invoice/sadqa-invoice.module').then( m => m.SadqaInvoicePageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'sadqa-list',
    loadChildren: () => import('./sadqa-list/sadqa-list.module').then( m => m.SadqaListPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'f-q',
    loadChildren: () => import('./f-q/f-q.module').then( m => m.FQPageModule)
  },
  {
    path: 'ring-birds',
    loadChildren: () => import('./ring-birds/ring-birds.module').then( m => m.RingBirdsPageModule)
  },
  {
    path: 'bird-category',
    loadChildren: () => import('./bird-category/bird-category.module').then( m => m.BirdCategoryPageModule)
  },
  {
    path: 'bird-dna',
    loadChildren: () => import('./bird-dna/bird-dna.module').then( m => m.BirdDnaPageModule)
  },
  {
    path: 'returne-policy',
    loadChildren: () => import('./returne-policy/returne-policy.module').then( m => m.ReturnePolicyPageModule)
  },
  {
    path: 'shipping-policy',
    loadChildren: () => import('./shipping-policy/shipping-policy.module').then( m => m.ShippingPolicyPageModule)
  },
  {
    path: 'all-feature',
    loadChildren: () => import('./all-feature/all-feature.module').then( m => m.AllFeaturePageModule)
  },
  {
    path: 'shipping',
    loadChildren: () => import('./shipping/shipping.module').then( m => m.ShippingPageModule)
  },
  {
    path: 'reach-us',
    loadChildren: () => import('./reach-us/reach-us.module').then( m => m.ReachUsPageModule)
  },
  {
    path: 'just-deliver-orders',
    loadChildren: () => import('./just-deliver-orders/just-deliver-orders.module').then( m => m.JustDeliverOrdersPageModule)
  },
  {
    path: 'just-deliver-inovice',
    loadChildren: () => import('./just-deliver-inovice/just-deliver-inovice.module').then( m => m.JustDeliverInovicePageModule)
  },
  {
    path: 'order-modal',
    loadChildren: () => import('./order-modal/order-modal.module').then( m => m.OrderModalPageModule)
  },

 




];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
